const o = "ArrowLeft", t = "ArrowUp", n = "ArrowRight", r = "ArrowDown", c = "Enter", s = "Escape", E = " ", A = "Tab";
export { r as DOWN, c as ENTER, s as ESC, o as LEFT, n as RIGHT, E as SPACE, A as TAB, t as UP };
